import { Component, OnInit, ViewEncapsulation, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import * as XLSX from 'xlsx';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DropdownRendererComponent } from 'src/common/dropdown-renderer';
import { ConfigurationService } from 'src/services/configuration.service';
import { LocalstorageService } from 'src/services/localstorage.service';
import { NgxToasterService } from 'src/services/ngx-toaster.service';

@Component({
  selector: 'app-forcast',
  templateUrl: './forcast.component.html',
  styleUrls: ['./forcast.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ForcastComponent implements OnInit {
  width = '100%';
  height = '500';
  type = "msline";
  dataFormat = "json";
  dataSource;
  public submitted = false;
  public isEdit = false;
  public columnDefs = [];
  private gridApi: any;
  dropdownSettings = {};
  dropdownSettingsSingle = {};
  public tenureTypeList = [];
  public tenureTypeListTemp = [];
  public rowList = [];
  public goalTypeList = [];
  public gridOptions: any;
  public getRowHeight;
  public getRowStyle;
  public headerHeight;
  public modules = AllCommunityModules;
  public clientId = 1;
  public channelList = [{ channelId: 1, channelName: 'Retail' }];
  public channel = null;
  public csvRecords: any;
  public customerSelectedList = [];
  public selectedItemIds = [];
  public itemIdList = ['FB000038',
    'FB000084',
    'FB000063'];
  public customerList = [
    'Amazon AU',
    'Amazon CA',
    'Amazon JPN',
    'Amazon US',
    'Best Buy CA',
    'Best Buy US',
    'Synnex CA',
    'Synnex US',
    'WMT'

  ];
  public timeframeSelectedList = [];
  public itemSeletedList = [];
  public timeframeList = [];
  public versionList = [];
  public monthList = [];
  public itemList = [
    'Quest 64GB - US/CA/JP/TW',
    'Quest 128GB - US/CA/JP/TW',
    'Portal+ Black',
    'Oculus Go Relaxed Facial Interface',
    'Oculus Go Charging Cable',
    'Oculus Rift S Headband',
    'Oculus Rift Headset (only)',
    'Oculus Rift S',
    'Audio Arms',
    'Oculus Touch - Left Controller',
    'Oculus Quest UK/IE/HK/SG 64GB',
    'Rock Band VR connector',
    'Earphones',
    'Quest 64GB - EU',
    'Portal Black',
    'Quest 64GB - UK/IE/HK/SG',
    'Oculus Go Controller (Grade B)',
    'Portal Black (Gen 2)',
    'Touch',
    'Portal TV (Catalina)',
    'Oculus Rift S Standard Facial Interface',
    'Portal Mini - Dark (CA)',
    'Portal Dark - (CA)',
    'Oculus Go Carry Case',
    'Portal TV (UK/IE)',
    'Oculus Go Standalone VR 32 GB',
    'Portal+ White',
    'Rift - Marvel Bundle',
    'Unknown Oculus Product',
    'Portal Mini - White',
    'Portal Light - (CA)',
    'Oculus Go - 64GB',
    'Quest 64GB - AU/NZ',
    'Oculus Quest 128GB',
    'Sensor',
    'Quest 128GB and Case Bundle (S10252627@AMA+S10260629)',
    'Portal + White - CA',
    'Quest 128GB - AU/NZ',
    'Portal White - CA',
    'Oculus Go Controller',
    'Portal Mini (Omni)',
    'Portal White',
    'Portal White (Gen 2)',
    'Portal Mini - Black',
    'Oculus Quest IEM',
    'Portal Mini - Dark (EU)',
    'Oculus Quest Travel case',
    'Portal (Atlas)',
    'Oculus Quest UK/IE/HK/SG 128GB',
    'Portal+ Dark - (EU)',
    'Portal Mini - White (CA)',
    'Quest 64GB and Case Bundle (S10252626@AMA+S10260629)',
    'Portal TV (CA)',
    'Oculus Go - 32GB',
    'Oculus Go 64GB Headset (Grade B)',
    'Rift S',
    'Rift S Device',
    'Oculus Rift',
    '15W USB-C Power Adapter for the United Kingdom, Ireland, Hong Kong and Singapore',
    'SID (Simple Input Device)',
    '15W USB-C Power Adapter for EU',
    'Quest 128GB -EU',
    'HMD cable',
    'Oculus Go - 32GB ROW',
    'Online Game Code',
    'Oculus Touch - Right Controller',
    'Hardbundle',
    'Oculus Go Facial Interface Eye Rings',
    'Portal Mini - White (EU)',
    'Portal+ Light - (EU)',
    'Oculus Quest 64GB',
    'Oculus Go - 64GB ROW',
    'Oculus Touch Right Hand Controller',
    '15W USB-C Power Adapter for USA, Canada, Japan and Taiwan',
    'Portal TV (EU)',
    'Portal TV',
    'Portal Dark - (UK/IE)',
    'Portal + Black - CA',
    'Quest 128GB - UK/IE/HK/SG',
    'Oculus Go - Carrying Case',
    'Oculus Go Fitted Facial Interface',
    'Portal+ Light - (UK/IE)',
    'Oculus Sensor',
    'Oculus Go Controller Lanyard',
    'Portal+ Dark - (UK/IE)"',
    'Quest In-ear Headphones',
    'Portal Dark - (EU)',
    '15W USB-C Power Adapter for Australia and New Zealand',
    'Oculus Go Glasses Spacer',
    'Oculus Go Power Adapter',
    'Portal Light - (UK/IE)',
    'Oculus Go 32GB Headset (Grade B)',
    'Quest Travel Case',
    'Oculus Quest Standard Facial Interface',
    'Portal Light - (EU)',
    'Rift',
    'Portal Black - CA',
    'Portal Mini - White (UK/IE)',
    'Oculus Go Standalone VR 64 GB',
    'Portal Mini - Dark (UK/IE)',
    'Oculus Touch Left Hand Controller'
  ];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredCustomers: Observable<any[]>;
  filteredItems: Observable<any[]>;
  filteredTimeframe: Observable<any[]>;
  public seletedYear = null;
  public seletedVersion = null;
  public selectedMonth = null;
  public defaultRow = {};
  public selectAll = true;
  searchCustomer = new FormControl();
  searchItem = new FormControl();
  searchTimeframe = new FormControl();
  files: File[] = [];
  @ViewChild('ExcelImport') excelImport: TemplateRef<any>;
  @ViewChild('dialog') dialogTemplate: TemplateRef<any>;
  @ViewChild('searchItemInput', { static: true }) searchItemInput: ElementRef;
  @ViewChild('searchCustomerInput', { static: true }) searchCustomerInput: ElementRef;
  tempList = [];
  totalCalculatedList = [];
  chartDatasets = [];
  simulatedChartDatasets = [];
  barChartDatasets = [];
  simulatedBarChartDatasets = [];
  xAxis = [];
  yAxis = [];
  xAxisSimulated = [];
  view = [700, 700];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  legendTitle = 'Legend';
  legendPosition = 'right';
  showXAxisLabel = true;
  xAxisLabel = 'Sales QTY';
  showYAxisLabel = true;
  yAxisLabel = 'Time Period';
  showGridLines = true;
  innerPadding = '10%';
  animations: boolean = true;
  lineChartScheme = {
    name: 'coolthree',
    selectable: true,
    group: 'Ordinal',
    domain: ['#01579b', '#7aa3e5', '#a8385d', '#00bfa5']
  };

  comboBarScheme = {
    name: 'singleLightBlue',
    selectable: true,
    group: 'Ordinal',
    domain: ['#7aa3e5']
  };

  showRightYAxisLabel: boolean = true;
  yAxisLabelRight: string = '';
  tempColDefs = [];
  chooserList = [
    { name: 'Primary Method Base', checked: true },
    { name: 'Event Lift', checked: true },
    { name: 'Seasonality', checked: true },
    { name: 'Total Forecast', checked: true },
    { name: 'Final Total Forecast', checked: true },
    { name: 'Customer Forecast', checked: true },
    { name: 'Monthly Budget', checked: true },
    { name: 'Yearly Budget', checked: true },
    { name: 'Marketing Spend', checked: true },
    { name: 'LY Actuals', checked: true },
    { name: 'Like Item LY', checked: true },
    { name: 'Notes', checked: true }
  ]
  // public  date = { begin: new Date(2018, 7, 5), end: new Date(2018, 7, 25) };
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public location: Location,
    public spinner: NgxSpinnerService,
    public toastr: NgxToasterService,
    public storage: LocalstorageService,
    public dialogRef: MatDialogRef<any>,
    public configurationService: ConfigurationService,
    public dialog: MatDialog) {
    this.gridOptions = {
      rowClassRules: {
        // apply green to 2008
        'rag-green-outer': function (params) { return params.data.secondValue === 'Final Total Forecast'; },
        'rag-grey-outer': function (params) { return (params.data.columnValue === 'Quest 128GB' || params.data.columnValue === 'Portal + Black' || params.data.columnValue === 'Quest 64GB'); },
        'rag-border-outer': function (params) {
          return params.data.secondValue === 'Notes';
        },
        'rag-border-top-outer': function (params) {
          return params.data.secondValue === 'Primary Method Base';
        },
        // // apply amber 2004
        // 'rag-amber-outer': function(params) { return params.data.year === 2004; },

        // // apply red to 2000
        // 'rag-red-outer': function(params) { return params.data.year === 2000; }
      },
      frameworkComponents: {
        dropdownRenderer: DropdownRendererComponent
      },
      // pagination: true,
      // paginationAutoPageSize: true,
      // suppressMenuHide: true,
    };
    this.headerHeight = 30;
    this.gridOptions.getRowHeight = function (params) {
      return 30;
    };
    this.gridOptions.getRowStyle = function (params) {
      if (params.data && params.data.apBudgetTenureName && typeof params.data.apBudgetTenureName === 'string') {
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.endsWith('FY21')) {
          return { 'background-color': '#D6EAF8' };
        }
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.startsWith('Q')) {
          return { 'background-color': '#3498DB' };
        }
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.startsWith('WK')) {
          return { 'background-color': '' };
        }
      }
    };
  }
  openDialog(data, templateRef?: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(this.dialogTemplate, { width: '500px', data: data || {} });
  }
  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
    this.dropdownSettingsSingle = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
    this.customerList = (this.customerList as any).map(customer => ({
      item_id: customer,
      item_text: customer
    }));
    this.itemList = (this.itemList as any).map(item => ({
      item_id: item,
      item_text: item
    }));
    this.versionList.push(
      'Commit',
      'V1',
      'V2',
      'V3'
    );
    for (let index = 0; index < 12; index++) {
      const date = new Date(2009, index, 10);  // 2009-11-10
      const month = date.toLocaleString('default', { month: 'long' });
      const shortMonth = date.toLocaleString('default', { month: 'short' });
      this.monthList.push(
        {
          item_id: `${shortMonth}`, item_text: `${month} FY20`
        });
    }
    this.customerList = (this.customerList as any).sort((a, b) => a.item_id < b.item_id ? -1 : 1)
    this.itemList = (this.itemList as any).sort((a, b) => a.item_id < b.item_id ? -1 : 1)
    this.searchCustomer.setValue('');
    this.searchItem.setValue('');
    this.columnDefs = [
      {
        headerName: '',
        width: 150,
        field: 'firstValue',
        pinned: 'abcd',
        cellRenderer: params => `<b>${params.value ? params.value : ''}</b>`,
        cellStyle: { 'background-color': 'white' }
      },
      {
        headerName: '',
        width: 200,
        pinned: 'abcd',
        field: 'secondValue',
        cellRenderer: 'dropdownRenderer',
        cellRendererParams: (params) => {
          const items = ['Primary Method Base', 'Expotential Smoothing', 'Linear Regression', `Holt's Double Expotential Smoothing`];
          const obj = {
            isDropDown: items.includes(params.data.secondValue) ? true : false, // pass the field value here
            items: items,
            onChange: this.filterData.bind(this),
          }
          return obj;

        },
        cellStyle: params => params.rowData && params.rowData.rowIndex % 2 === 0 ? { 'background-color': 'white' } : { 'background-color': 'lightgray' }
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/05/2020',
            width: 120,
            field: 'janw1',
            suppressSizeToFit: true,
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          }
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/12/2020',
            width: 120,
            field: 'janw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/19/2020',
            width: 120,
            field: 'janw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/26/2020',
            width: 120,
            field: 'janw4',
            pivotIndex: 0,
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },

        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl January',
            width: 150,
            field: 'ttlJanuary',
            valueGetter: (params) => {
              if (params.data.ttlJanuary) {
                return params.data.ttlJanuary;
              } else {
                return '';
              }
            },
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },

        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/02/2020',
            width: 120,
            field: 'febw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/09/2020',
            width: 120,
            field: 'febw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/16/2020',
            width: 120,
            field: 'febw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/23/2020',
            width: 120,
            field: 'febw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl February',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlFebruary) {
                return params.data.ttlFebruary;
              } else {
                return '';
              }
            },
            field: 'ttlFebruary',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/01/2020',
            width: 120,
            field: 'marchw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '03/08/2020',
            width: 120,
            field: 'marchw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '03/15/2020',
            width: 120,
            field: 'marchw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/22/2020',
            width: 120,
            field: 'marchw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/29/2020',
            width: 120,
            field: 'marchw5',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl March',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlMarch) {
                return params.data.ttlMarch;
              } else {
                return '';
              }
            },
            field: 'ttlMarch',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q1',
            width: 120,
            field: 'q1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q1) {
                return params.data.q1;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/05/2020',
            width: 120,
            field: 'aprilw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/12/2020',
            width: 120,
            field: 'aprilw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/19/2020',
            width: 120,
            field: 'aprilw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/26/2020',
            width: 120,
            field: 'aprilw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl April',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlApril) {
                return params.data.ttlApril;
              } else {
                return '';
              }
            },
            field: 'ttlApril',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/03/2020',
            width: 120,
            field: 'mayw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/10/2020',
            width: 120,
            field: 'mayw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '05/17/2020',
            width: 120,
            field: 'mayw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/24/2020',
            width: 120,
            field: 'mayw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl May',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlMay) {
                return params.data.ttlMay;
              } else {
                return '';
              }
            },
            field: 'ttlMay',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '05/31/2020',
            width: 120,
            field: 'junew1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '06/07/2020',
            width: 120,
            field: 'junew2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/14/2020',
            width: 120,
            field: 'junew3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/21/2020',
            width: 120,
            field: 'junew4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/28/2020',
            width: 120,
            field: 'junew5',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl June',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlJune) {
                return params.data.ttlJune;
              } else {
                return '';
              }
            },
            field: 'ttlJune',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q2',
            width: 120,
            field: 'q2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q2) {
                return params.data.q2;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/05/2020',
            width: 120,
            field: 'julyw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/12/2020',
            width: 120,
            field: 'julyw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '07/19/2020',
            width: 120,
            field: 'julyw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/26/2020',
            width: 120,
            field: 'julyw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl July',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlJuly) {
                return params.data.ttlJuly;
              } else {
                return '';
              }
            },
            field: 'ttlJuly',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/02/2020',
            width: 120,
            field: 'augw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/09/2020',
            width: 120,
            field: 'augw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/16/2020',
            width: 120,
            field: 'augw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '08/23/2020',
            width: 120,
            field: 'augw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl August',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlAugust) {
                return params.data.ttlAugust;
              } else {
                return '';
              }
            },
            field: 'ttlAugust',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/30/2020',
            width: 120,
            field: 'sepw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/13/2020',
            width: 120,
            field: 'sepw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/20/2020',
            width: 120,
            field: 'sepw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/27/2020',
            width: 120,
            field: 'sepw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl September',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlSeptember) {
                return params.data.ttlSeptember;
              } else {
                return '';
              }
            },
            field: 'ttlSeptember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q3',
            width: 120,
            field: 'q3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q3) {
                return params.data.q3;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '10/04/2020',
            width: 120,
            field: 'octw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '10/11/2020',
            width: 120,
            field: 'octw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '10/18/2020',
            width: 120,
            field: 'octw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' }
          },
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '10/25/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'octw4',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl October',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlOctober) {
                return params.data.ttlOctober;
              } else {
                return '';
              }
            },
            field: 'ttlOctober',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/01/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw1',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/08/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw2',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/15/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw3',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/22/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw4',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl November',
            width: 150,
            field: 'ttlNovember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.ttlNovember) {
                return params.data.ttlNovember;
              } else {
                return '';
              }
            }
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/29/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'novw5',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/06/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'decw1',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/13/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'decw2',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/20/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'decw3',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/27/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Total Forecast' },
            width: 120,
            field: 'decw4',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl December',
            width: 150,
            field: 'ttlDecember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.ttlDecember) {
                return params.data.ttlDecember;
              } else {
                return '';
              }
            }
          },
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Q4',
            width: 120,
            field: 'q4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q4 && params.data.secondValue === 'Seasonality') {
                return Number(params.data.q4).toFixed(2);
              } else {
                if (params.data.q4) {
                  return Number(params.data.q4);
                } else {
                  return '';
                }
              }
            }
          }
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Total Year',
            width: 120,
            field: 'totalYear',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.totalYear) {
                return params.data.totalYear;
              } else {
                return '';
              }
            }
          }
        ]
      },

    ];
    this.tempColDefs = JSON.parse(JSON.stringify(this.columnDefs));
    const defaultObject = {
      firstValue: 'Quest 128GB',
      secondValue: 'Final Base',
      janw1: 957,
      janw2: 974,
      janw3: 832,
      janw4: 969,
      janw5: 969,
      ttlJanuary: 3731,
      febw1: 957,
      febw2: 974,
      febw3: 832,
      febw4: 969,
      febw5: 969,
      ttlFebruary: 3731,
      marchw1: 957,
      marchw2: 974,
      marchw3: 832,
      marchw4: 969,
      marchw5: 969,
      ttlMarch: 3731,
      q1: 1000,
      aprilw1: 957,
      aprilw2: 974,
      aprilw3: 832,
      aprilw4: 969,
      aprilw5: 969,
      ttlApril: 3731,
      mayw1: 957,
      mayw2: 974,
      mayw3: 832,
      mayw4: 969,
      mayw5: 969,
      ttlMay: 3731,
      junew1: 957,
      junew2: 974,
      junew3: 832,
      junew4: 969,
      junew5: 969,
      ttlJune: 3731,
      q2: 1000,
      julyw1: 957,
      julyw2: 974,
      julyw3: 832,
      julyw4: 969,
      julyw5: 969,
      ttlJuly: 3731,
      augw1: 957,
      augw2: 974,
      augw3: 832,
      augw4: 969,
      augw5: 969,
      ttlAugust: 3731,
      sepw1: 957,
      sepw2: 974,
      sepw3: 832,
      sepw4: 969,
      sepw5: 969,
      ttlSepetember: 3731,
      q3: 1000,
      octw1: 957,
      octw2: 974,
      octw3: 832,
      octw4: 969,
      octw5: 969,
      ttlOctober: 3731,
      novw1: 957,
      novw2: 974,
      novw3: 832,
      novw4: 969,
      novw5: 969,
      ttlNovemebr: 3731,
      decw1: 957,
      decw2: 974,
      decw3: 832,
      decw4: 969,
      decw5: 969,
      ttlDecember: 3731,
      q4: 1000,
      totalYear: 5000
    }
    // this.columnDefs.forEach((column) => this.defaultRow[column.field] = Math.random());
    const manupulatedList = [];
    const obj = JSON.parse(JSON.stringify(this.defaultRow));
    for (let index = 1; index <= 48; index++) {
      this.rowList.push(defaultObject);
    }
    // this.configurationService.importExcel('forcast-data').subscribe(res => {
    //   this.loadFile(res);
    // });
    this.rowList = [{ "columnValue": "Calculated", "secondValue": "Mostly likely Method", "janw1": 0, "janw2": 0, "janw3": 0, "janw4": 0, "ttlJanuary": 0, "febw1": 0, "febw2": 0, "febw3": 0, "febw4": 0, "ttlFebruary": 0, "marchw1": 0, "marchw2": 0, "marchw3": 0, "marchw4": 0, "marchw5": 0, "ttlMarch": 0, "q1": 0, "aprilw1": 0, "aprilw2": 0, "aprilw3": 0, "aprilw4": 0, "ttlApril": 0, "mayw1": 0, "mayw2": 0, "mayw3": 0, "mayw4": 0, "ttlMay": 0, "junew1": 0, "junew2": 0, "junew3": 0, "junew4": 0, "junew5": 0, "ttlJune": 0, "q2": 0, "julyw1": 0, "julyw2": 0, "julyw3": 0, "julyw4": 0, "ttlJuly": 0, "augw1": 0, "augw2": 0, "augw3": 0, "augw4": 0, "ttlAugust": 0, "sepw1": 0, "sepw2": 0, "sepw3": 0, "sepw4": 0, "sepw5": 0, "ttlSeptember": 0, "q3": 0, "octw1": 0, "octw2": 0, "octw3": 0, "octw4": 0, "ttlOctober": 0, "novw1": 0, "novw2": 0, "novw3": 0, "novw4": 0, "ttlNovember": 0, "novw5": 0, "decw1": 0, "decw2": 0, "decw3": 0, "decw4": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Calculated", "secondValue": "Likely Method", "janw1": 1633.905, "janw2": 1760.7869999999998, "janw3": 1699.1414999999997, "janw4": 1701.5355, "ttlJanuary": 6795.368999999999, "febw1": 1299.384, "febw2": 1583.7839999999999, "febw3": 3908.9699999999993, "febw4": 3329.0190000000002, "ttlFebruary": 10121.157, "marchw1": 3689.7525000000005, "marchw2": 6304.0005, "marchw3": 6112.4805, "marchw4": 5509.1925, "marchw5": 3728.6549999999997, "ttlMarch": 25344.081, "q1": 42260.606999999996, "aprilw1": 3948.3044999999993, "aprilw2": 2808.162, "aprilw3": 2893.149, "aprilw4": 1915.7984999999996, "ttlApril": 11565.413999999999, "mayw1": 1589.6159999999998, "mayw2": 1687.1715, "mayw3": 2084.5755, "mayw4": 1881.6839999999997, "ttlMay": 7243.047, "junew1": 1408.2705, "junew2": 1529.1675, "junew3": 2149.2135, "junew4": 2478.9869999999996, "junew5": 1806.2729999999997, "ttlJune": 9371.911499999998, "q2": 28180.372499999998, "julyw1": 2252.1555, "julyw2": 1987.0199999999998, "julyw3": 1709.3159999999998, "julyw4": 2183.9264999999996, "ttlJuly": 8132.417999999999, "augw1": 1294.5554999999997, "augw2": 2238.9885, "augw3": 4430.097, "augw4": 9331.213499999998, "ttlAugust": 17294.854499999998, "sepw1": 2138.4405, "sepw2": 2209.662, "sepw3": 2143.2284999999997, "sepw4": 2062.4309999999996, "sepw5": 2422.7279999999996, "ttlSeptember": 10976.49, "q3": 36403.7625, "octw1": 1943.928, "octw2": 1821.2355, "octw3": 1817.046, "octw4": 1697.3459999999998, "ttlOctober": 7279.5555, "novw1": 1697.3459999999998, "novw2": 1451.961, "novw3": 1332.2609999999997, "novw4": 1332.2609999999997, "ttlNovember": 5813.829, "novw5": 1332.2609999999997, "decw1": 1329.867, "decw2": 1210.7655, "decw3": 1451.961, "decw4": 1329.867, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Calculated", "secondValue": "Unlikely Method", "janw1": 1270.8149999999998, "janw2": 1369.5009999999997, "janw3": 1321.5544999999997, "janw4": 1323.4164999999998, "ttlJanuary": 5285.286999999999, "febw1": 1010.632, "febw2": 1231.8319999999997, "febw3": 3040.3099999999995, "febw4": 2589.237, "ttlFebruary": 7872.0109999999995, "marchw1": 2869.8075, "marchw2": 4903.111499999999, "marchw3": 4754.151499999999, "marchw4": 4284.9275, "marchw5": 2900.0649999999996, "ttlMarch": 19712.062999999995, "q1": 32869.361, "aprilw1": 3070.9034999999994, "aprilw2": 2184.1259999999997, "aprilw3": 2250.2269999999994, "aprilw4": 1490.0654999999995, "ttlApril": 8995.321999999998, "mayw1": 1236.3679999999997, "mayw2": 1312.2444999999998, "mayw3": 1621.3364999999997, "mayw4": 1463.5319999999997, "ttlMay": 5633.480999999999, "junew1": 1095.3215, "junew2": 1189.3525, "junew3": 1671.6104999999998, "junew4": 1928.1009999999994, "junew5": 1404.8789999999997, "ttlJune": 7289.264499999998, "q2": 21918.067499999997, "julyw1": 1751.6764999999996, "julyw2": 1545.4599999999998, "julyw3": 1329.4679999999998, "julyw4": 1698.6094999999996, "ttlJuly": 6325.213999999999, "augw1": 1006.8764999999997, "augw2": 1741.4354999999998, "augw3": 3445.631, "augw4": 7257.610499999998, "ttlAugust": 13451.553499999998, "sepw1": 1663.2314999999999, "sepw2": 1718.6259999999997, "sepw3": 1666.9554999999998, "sepw4": 1604.1129999999996, "sepw5": 1884.3439999999996, "ttlSeptember": 8537.269999999999, "q3": 28314.037499999995, "octw1": 1511.944, "octw2": 1416.5165, "octw3": 1413.258, "octw4": 1320.158, "ttlOctober": 5661.8765, "novw1": 1320.158, "novw2": 1129.3029999999999, "novw3": 1036.2029999999997, "novw4": 1036.2029999999997, "ttlNovember": 4521.866999999999, "novw5": 1036.2029999999997, "decw1": 1034.341, "decw2": 941.7064999999998, "decw3": 1129.3029999999999, "decw4": 1034.341, "ttlDecember": 0 }, { "columnValue": "Calculated", "firstValue": "Sum of item", "secondValue": "Final Total Forecast", "janw1": 0, "janw2": 0, "janw3": 0, "janw4": 0, "ttlJanuary": 0, "febw1": 0, "febw2": 0, "febw3": 0, "febw4": 0, "ttlFebruary": 0, "marchw1": 0, "marchw2": 0, "marchw3": 0, "marchw4": 0, "marchw5": 0, "ttlMarch": 0, "q1": 0, "aprilw1": 0, "aprilw2": 0, "aprilw3": 0, "aprilw4": 0, "ttlApril": 0, "mayw1": 0, "mayw2": 0, "mayw3": 0, "mayw4": 0, "ttlMay": 0, "junew1": 0, "junew2": 0, "junew3": 0, "junew4": 0, "junew5": 0, "ttlJune": 0, "q2": 0, "julyw1": 0, "julyw2": 0, "julyw3": 0, "julyw4": 0, "ttlJuly": 0, "augw1": 0, "augw2": 0, "augw3": 0, "augw4": 0, "ttlAugust": 0, "sepw1": 0, "sepw2": 0, "sepw3": 0, "sepw4": 0, "sepw5": 0, "ttlSeptember": 0, "q3": 0, "octw1": 0, "octw2": 0, "octw3": 0, "octw4": 0, "ttlOctober": 0, "novw1": 0, "novw2": 0, "novw3": 0, "novw4": 0, "ttlNovember": 0, "novw5": 0, "decw1": 0, "decw2": 0, "decw3": 0, "decw4": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 128GB", "secondValue": "Primary Method Base", "janw1": 909.055, "janw2": 925.0149999999999, "janw3": 790.0199999999999, "janw4": 920.3599999999999, "ttlJanuary": 3544.4499999999994, "febw1": 550, "febw2": 600, "febw3": 3000, "febw4": 2200, "ttlFebruary": 6350, "marchw1": 1044.05, "marchw2": 2414.615, "marchw3": 2517.6899999999996, "marchw4": 2630.075, "marchw5": 1616.6149999999998, "ttlMarch": 10223.044999999998, "q1": 20117.495, "aprilw1": 1557.4299999999998, "aprilw2": 1677.7949999999998, "aprilw3": 760.7599999999999, "aprilw4": 996.8349999999999, "ttlApril": 4992.82, "mayw1": 936.9849999999999, "mayw2": 1047.375, "mayw3": 678.3, "mayw4": 1068.6549999999997, "ttlMay": 3731.3149999999996, "junew1": 526.68, "junew2": 658.35, "junew3": 799.9949999999999, "junew4": 985.5299999999999, "junew5": 986.1949999999998, "ttlJune": 3956.749999999999, "q2": 12680.884999999998, "julyw1": 744.1349999999999, "julyw2": 924.3499999999998, "julyw3": 958.2649999999999, "julyw4": 708.8899999999999, "ttlJuly": 3335.6399999999994, "augw1": 516.7049999999999, "augw2": 963.5849999999999, "augw3": 1622.6, "augw4": 3845.0299999999993, "ttlAugust": 6947.919999999999, "sepw1": 781.375, "sepw2": 807.9749999999999, "sepw3": 783.3699999999999, "sepw4": 753.4449999999998, "sepw5": 886.4449999999998, "ttlSeptember": 4012.609999999999, "q3": 14296.169999999998, "octw1": 709.555, "octw2": 665, "octw3": 665, "octw4": 620.4449999999999, "ttlOctober": 2660, "novw1": 620.4449999999999, "novw2": 532, "novw3": 487.445, "novw4": 487.445, "ttlNovember": 2127.335, "novw5": 487.445, "decw1": 487.445, "decw2": 443.55499999999995, "decw3": 532, "decw4": 487.445, "ttlDecember": 4245.228, "q4": 12581.67, "totalYear": 93545.10999999999 }, { "columnValue": "Quest 128GB", "secondValue": "Event Lift", "janw1": 410.09999999999997, "janw2": 417.3, "janw3": 356.4, "janw4": 415.2, "ttlJanuary": 1598.9999999999998, "febw1": 500, "febw2": 405.59999999999997, "febw3": 332.7, "febw4": 565.8, "ttlFebruary": 1804.1, "marchw1": 471, "marchw2": 1089.3, "marchw3": 1135.8, "marchw4": 1186.5, "marchw5": 729.3, "ttlMarch": 4611.9, "q1": 8015, "aprilw1": 702.6, "aprilw2": 756.9, "aprilw3": 343.2, "aprilw4": 449.7, "ttlApril": 2252.4, "mayw1": 422.7, "mayw2": 472.5, "mayw3": 306, "mayw4": 482.09999999999997, "ttlMay": 1683.3, "junew1": 237.6, "junew2": 297, "junew3": 360.9, "junew4": 444.59999999999997, "junew5": 444.9, "ttlJune": 1785, "q2": 5720.700000000001, "julyw1": 335.7, "julyw2": 417, "julyw3": 432.3, "julyw4": 319.8, "ttlJuly": 1504.8, "augw1": 233.1, "augw2": 434.7, "augw3": 732, "augw4": 1734.6, "ttlAugust": 3134.3999999999996, "sepw1": 352.5, "sepw2": 364.5, "sepw3": 353.4, "sepw4": 339.9, "sepw5": 399.9, "ttlSeptember": 1810.1999999999998, "q3": 6449.4, "octw1": 320.09999999999997, "octw2": 300, "octw3": 300, "octw4": 279.9, "ttlOctober": 1200, "novw1": 279.9, "novw2": 240, "novw3": 219.9, "novw4": 219.9, "ttlNovember": 959.6999999999999, "novw5": 219.9, "decw1": 219.9, "decw2": 200.1, "decw3": 240, "decw4": 219.9, "ttlDecember": 2932.8, "q4": 8692, "totalYear": 61968.8 }, { "columnValue": "Quest 128GB", "secondValue": "Seasonality", "janw1": 1.2, "janw2": 1.2, "janw3": 1.2, "janw4": 1.2, "ttlJanuary": 4.8, "febw1": 1.2, "febw2": 1.2, "febw3": 1.2, "febw4": 1.2, "ttlFebruary": 4.8, "marchw1": 1.2, "marchw2": 1.2, "marchw3": 1.2, "marchw4": 1.2, "marchw5": 1.2, "ttlMarch": 6, "aprilw1": 1.2, "aprilw2": 1.2, "aprilw3": 1.2, "aprilw4": 1.2, "ttlApril": 4.8, "mayw1": 1.2, "mayw2": 1.2, "mayw3": 1.2, "mayw4": 1.2, "ttlMay": 4.8, "junew1": 1.2, "junew2": 1.2, "junew3": 1.2, "junew4": 1.2, "junew5": 1.2, "ttlJune": 6, "julyw1": 1.2, "julyw2": 1.2, "julyw3": 1.2, "julyw4": 1.2, "ttlJuly": 4.8, "augw1": 1.2, "augw2": 1.2, "augw3": 1.2, "augw4": 1.2, "ttlAugust": 4.8, "sepw1": 1.2, "sepw2": 1.2, "sepw3": 1.2, "sepw4": 1.2, "sepw5": 1.2, "ttlSeptember": 6, "octw1": 1.2, "octw2": 1.2, "octw3": 1.2, "octw4": 1.2, "ttlOctober": 4.8, "novw1": 1.2, "novw2": 1.2, "novw3": 1.2, "novw4": 1.2, "ttlNovember": 4.8, "novw5": 1.2, "decw1": 1.2, "decw2": 1.2, "decw3": 1.2, "decw4": 1.2, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 128GB", "secondValue": "Total Forecast", "janw1": 0, "janw2": 0, "janw3": 0, "janw4": 0, "ttlJanuary": 0, "febw1": 0, "febw2": 0, "febw3": 0, "febw4": 0, "ttlFebruary": 0, "marchw1": 0, "marchw2": 0, "marchw3": 0, "marchw4": 0, "marchw5": 0, "ttlMarch": 0, "q1": 0, "aprilw1": 0, "aprilw2": 0, "aprilw3": 0, "aprilw4": 0, "ttlApril": 0, "mayw1": 0, "mayw2": 0, "mayw3": 0, "mayw4": 0, "ttlMay": 0, "junew1": 0, "junew2": 0, "junew3": 0, "junew4": 0, "junew5": 0, "ttlJune": 0, "q2": 0, "julyw1": 0, "julyw2": 0, "julyw3": 0, "julyw4": 0, "ttlJuly": 0, "augw1": 0, "augw2": 0, "augw3": 0, "augw4": 0, "ttlAugust": 0, "sepw1": 0, "sepw2": 0, "sepw3": 0, "sepw4": 0, "sepw5": 0, "ttlSeptember": 0, "q3": 0, "octw1": 0, "octw2": 0, "octw3": 0, "octw4": 0, "ttlOctober": 0, "novw1": 0, "novw2": 0, "novw3": 0, "novw4": 0, "ttlNovember": 0, "novw5": 0, "decw1": 0, "decw2": 0, "decw3": 0, "decw4": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 128GB", "firstValue": "Quest 128GB", "secondValue": "Final Total Forecast", "janw1": 1750, "janw2": 1600, "janw3": 1500, "janw4": 1550, "ttlJanuary": 6400, "febw1": 1260, "febw2": 1206.7199999999998, "febw3": 3999.24, "febw4": 3318.96, "ttlFebruary": 9784.92, "marchw1": 1818.06, "marchw2": 4204.697999999999, "marchw3": 4384.187999999999, "marchw4": 4579.889999999999, "marchw5": 2815.098, "ttlMarch": 17801.934, "q1": 33986.854, "aprilw1": 2712.0359999999996, "aprilw2": 2921.6339999999996, "aprilw3": 1324.7519999999997, "aprilw4": 1735.8419999999999, "ttlApril": 8694.264, "mayw1": 1631.6219999999998, "mayw2": 1823.85, "mayw3": 1181.1599999999999, "mayw4": 1860.9059999999995, "ttlMay": 6497.537999999999, "junew1": 917.136, "junew2": 1146.42, "junew3": 1393.0739999999998, "junew4": 1716.1559999999997, "junew5": 1717.3139999999996, "ttlJune": 6890.0999999999985, "q2": 22081.901999999995, "julyw1": 1295.8019999999997, "julyw2": 1609.62, "julyw3": 1668.6779999999997, "julyw4": 1234.4279999999997, "ttlJuly": 5808.527999999998, "augw1": 899.766, "augw2": 1677.9419999999998, "augw3": 2825.52, "augw4": 6695.555999999999, "ttlAugust": 12098.783999999998, "sepw1": 1360.6499999999999, "sepw2": 1406.9699999999998, "sepw3": 1364.124, "sepw4": 1312.0139999999997, "sepw5": 1543.6139999999998, "ttlSeptember": 6987.371999999999, "q3": 24894.683999999994, "octw1": 1235.586, "octw2": 1158, "octw3": 1158, "octw4": 1080.4139999999998, "ttlOctober": 4632, "novw1": 1080.4139999999998, "novw2": 926.4, "novw3": 848.814, "novw4": 848.814, "ttlNovember": 3704.4419999999996, "novw5": 848.814, "decw1": 848.814, "decw2": 772.386, "decw3": 926.4, "decw4": 848.814, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 128GB", "firstValue": "BBY US", "secondValue": "Customer Forecast", "janw1": 1093.6000000000001, "janw2": 1112.8, "janw3": 950.4000000000001, "janw4": 1107.2, "ttlJanuary": 4264.000000000001, "febw1": 783.2, "febw2": 1081.6000000000001, "febw3": 887.2, "febw4": 1508.8, "ttlFebruary": 4260.8, "marchw1": 1256, "marchw2": 2904.8, "marchw3": 3028.8, "marchw4": 3164, "marchw5": 1944.8000000000002, "ttlMarch": 12298.400000000001, "q1": 20823.2, "aprilw1": 1873.6000000000001, "aprilw2": 2018.4, "aprilw3": 915.2, "aprilw4": 1199.2, "ttlApril": 6006.400000000001, "mayw1": 1127.2, "mayw2": 1260, "mayw3": 816, "mayw4": 1285.6, "ttlMay": 4488.8, "junew1": 633.6, "junew2": 792, "junew3": 962.4000000000001, "junew4": 1185.6, "junew5": 1186.4, "ttlJune": 4760, "q2": 15255.2, "julyw1": 895.2, "julyw2": 1112, "julyw3": 1152.8, "julyw4": 852.8000000000001, "ttlJuly": 4012.8, "augw1": 621.6, "augw2": 1159.2, "augw3": 1952, "augw4": 4625.6, "ttlAugust": 8358.4, "sepw1": 940, "sepw2": 972, "sepw3": 942.4000000000001, "sepw4": 906.4000000000001, "sepw5": 1066.4, "ttlSeptember": 4827.200000000001, "q3": 17198.4, "octw1": 853.6, "octw2": 800, "octw3": 800, "octw4": 746.4, "ttlOctober": 3200, "novw1": 746.4, "novw2": 640, "novw3": 586.4, "novw4": 586.4, "ttlNovember": 2559.2, "novw5": 586.4, "decw1": 586.4, "decw2": 533.6, "decw3": 640, "decw4": 586.4, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 128GB", "secondValue": "Monthly Budget", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 128GB", "secondValue": "Yearly Budget", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0 }, { "columnValue": "Quest 128GB", "secondValue": "Marketing Spend", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 6 }, { "columnValue": "Quest 128GB", "secondValue": "LY Actuals", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 128GB", "secondValue": "Like Item LY", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 4877.109999999999, "q4": 14453.774999999998, "totalYear": 84482.93 }, { "columnValue": "Quest 128GB", "secondValue": "Notes", "janw2": "Email, Ad", "janw4": "Ad, Email", "febw2": "10% Price", "febw4": "Free shipping", "marchw3": "Ad", "aprilw1": "Digital Ad", "aprilw4": "Email", "mayw1": "Bundle", "mayw4": "Global homepage", "junew2": "Commercial", "junew5": "In-store hot price", "julyw4": "Online only hot price", "augw4": "Ad", "sepw2": "Bunlde", "sepw5": "Email", "octw2": "Digital ad", "novw1": "Commercial", "novw4": "Email blast", "decw2": "Digital ad", "ttlDecember": 2200.2, "q4": 6520.5, "totalYear": 38112.6 }, { "ttlDecember": 6 }, { "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 64GB", "secondValue": "Primary Method Base", "janw1": 890.435, "janw2": 1014.125, "janw3": 1062.0049999999999, "janw4": 953.6099999999999, "ttlJanuary": 3920.1749999999997, "febw1": 866.4949999999999, "febw2": 1141.1399999999999, "febw3": 1307.3899999999999, "febw4": 1475.635, "ttlFebruary": 4790.66, "marchw1": 2994.495, "marchw2": 4514.6849999999995, "marchw3": 4177.53, "marchw4": 3404.7999999999997, "marchw5": 2421.265, "ttlMarch": 17512.774999999998, "q1": 26223.609999999997, "aprilw1": 2771.72, "aprilw2": 1362.5849999999998, "aprilw3": 2402.645, "aprilw4": 1079.9599999999998, "ttlApril": 7616.91, "mayw1": 786.03, "mayw2": 794.0099999999999, "mayw3": 1602.6499999999999, "mayw4": 981.54, "ttlMay": 4164.23, "junew1": 1010.8, "junew2": 1020.1099999999999, "junew3": 1548.12, "junew4": 1748.9499999999996, "junew5": 998.165, "ttlJune": 6326.1449999999995, "q2": 18107.285, "julyw1": 1731.6599999999999, "julyw2": 1243.55, "julyw3": 900.41, "julyw4": 1693.0899999999997, "ttlJuly": 5568.709999999999, "augw1": 899.0799999999999, "augw2": 1501.57, "augw3": 3258.5, "augw4": 6443.184999999999, "ttlAugust": 12102.334999999997, "sepw1": 1563.4149999999997, "sepw2": 1615.9499999999998, "sepw3": 1566.7399999999998, "sepw4": 1507.5549999999998, "sepw5": 1773.5549999999998, "ttlSeptember": 8027.214999999999, "q3": 25698.259999999995, "octw1": 1418.445, "octw2": 1330, "octw3": 1330, "octw4": 1241.5549999999998, "ttlOctober": 5320, "novw1": 1241.5549999999998, "novw2": 1064, "novw3": 975.5549999999998, "novw4": 975.5549999999998, "ttlNovember": 4256.664999999999, "novw5": 975.5549999999998, "decw1": 975.5549999999998, "decw2": 886.4449999999998, "decw3": 1064, "decw4": 975.5549999999998, "ttlDecember": 8492.771999999999, "q4": 25169.129999999997, "totalYear": 147114.63599999997 }, { "columnValue": "Quest 64GB", "secondValue": "Event Lift", "janw1": 401.7, "janw2": 457.5, "janw3": 479.09999999999997, "janw4": 430.2, "ttlJanuary": 1768.5, "febw1": 390.9, "febw2": 514.8, "febw3": 589.8, "febw4": 665.6999999999999, "ttlFebruary": 2161.2, "marchw1": 1350.8999999999999, "marchw2": 2036.6999999999998, "marchw3": 1884.6, "marchw4": 1536, "marchw5": 1092.3, "ttlMarch": 7900.499999999999, "q1": 11830.199999999999, "aprilw1": 1250.3999999999999, "aprilw2": 614.6999999999999, "aprilw3": 1083.8999999999999, "aprilw4": 487.2, "ttlApril": 3436.2, "mayw1": 354.59999999999997, "mayw2": 358.2, "mayw3": 723, "mayw4": 442.8, "ttlMay": 1878.6, "junew1": 456, "junew2": 460.2, "junew3": 698.4, "junew4": 789, "junew5": 450.3, "ttlJune": 2853.8999999999996, "q2": 8168.7, "julyw1": 781.1999999999999, "julyw2": 561, "julyw3": 406.2, "julyw4": 763.8, "ttlJuly": 2512.2, "augw1": 405.59999999999997, "augw2": 677.4, "augw3": 1470, "augw4": 2906.7, "ttlAugust": 5459.7, "sepw1": 705.3, "sepw2": 729, "sepw3": 706.8, "sepw4": 680.1, "sepw5": 800.1, "ttlSeptember": 3621.3, "q3": 11593.2, "octw1": 639.9, "octw2": 600, "octw3": 600, "octw4": 560.1, "ttlOctober": 2400, "novw1": 560.1, "novw2": 480, "novw3": 440.09999999999997, "novw4": 440.09999999999997, "ttlNovember": 1920.2999999999997, "novw5": 440.09999999999997, "decw1": 440.09999999999997, "decw2": 399.9, "decw3": 480, "decw4": 440.09999999999997, "ttlDecember": 5867.200000000001, "q4": 17388, "totalYear": 101633.6 }, { "columnValue": "Quest 64GB", "secondValue": "Seasonality", "janw1": 1.2, "janw2": 1.2, "janw3": 1.2, "janw4": 1.2, "ttlJanuary": 4.8, "febw1": 1.2, "febw2": 1.2, "febw3": 1.2, "febw4": 1.2, "ttlFebruary": 4.8, "marchw1": 1.2, "marchw2": 1.2, "marchw3": 1.2, "marchw4": 1.2, "marchw5": 1.2, "ttlMarch": 6, "aprilw1": 1.2, "aprilw2": 1.2, "aprilw3": 1.2, "aprilw4": 1.2, "ttlApril": 4.8, "mayw1": 1.2, "mayw2": 1.2, "mayw3": 1.2, "mayw4": 1.2, "ttlMay": 4.8, "junew1": 1.2, "junew2": 1.2, "junew3": 1.2, "junew4": 1.2, "junew5": 1.2, "ttlJune": 6, "julyw1": 1.2, "julyw2": 1.2, "julyw3": 1.2, "julyw4": 1.2, "ttlJuly": 4.8, "augw1": 1.2, "augw2": 1.2, "augw3": 1.2, "augw4": 1.2, "ttlAugust": 4.8, "sepw1": 1.2, "sepw2": 1.2, "sepw3": 1.2, "sepw4": 1.2, "sepw5": 1.2, "ttlSeptember": 6, "octw1": 1.2, "octw2": 1.2, "octw3": 1.2, "octw4": 1.2, "ttlOctober": 4.8, "novw1": 1.2, "novw2": 1.2, "novw3": 1.2, "novw4": 1.2, "ttlNovember": 4.8, "novw5": 1.2, "decw1": 1.2, "decw2": 1.2, "decw3": 1.2, "decw4": 1.2, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 64GB", "secondValue": "Total Forecast", "janw1": 0, "janw2": 0, "janw3": 0, "janw4": 0, "ttlJanuary": 0, "febw1": 0, "febw2": 0, "febw3": 0, "febw4": 0, "ttlFebruary": 0, "marchw1": 0, "marchw2": 0, "marchw3": 0, "marchw4": 0, "marchw5": 0, "ttlMarch": 0, "q1": 0, "aprilw1": 0, "aprilw2": 0, "aprilw3": 0, "aprilw4": 0, "ttlApril": 0, "mayw1": 0, "mayw2": 0, "mayw3": 0, "mayw4": 0, "ttlMay": 0, "junew1": 0, "junew2": 0, "junew3": 0, "junew4": 0, "junew5": 0, "ttlJune": 0, "q2": 0, "julyw1": 0, "julyw2": 0, "julyw3": 0, "julyw4": 0, "ttlJuly": 0, "augw1": 0, "augw2": 0, "augw3": 0, "augw4": 0, "ttlAugust": 0, "sepw1": 0, "sepw2": 0, "sepw3": 0, "sepw4": 0, "sepw5": 0, "ttlSeptember": 0, "q3": 0, "octw1": 0, "octw2": 0, "octw3": 0, "octw4": 0, "ttlOctober": 0, "novw1": 0, "novw2": 0, "novw3": 0, "novw4": 0, "ttlNovember": 0, "novw5": 0, "decw1": 0, "decw2": 0, "decw3": 0, "decw4": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 64GB", "firstValue": "Quest 64GB", "secondValue": "Final Total Forecast", "janw1": 1550.562, "janw2": 1765.95, "janw3": 1849.3259999999996, "janw4": 1660.572, "ttlJanuary": 6826.409999999999, "febw1": 1508.874, "febw2": 1987.1279999999997, "febw3": 2276.6279999999997, "febw4": 2569.602, "ttlFebruary": 8342.232, "marchw1": 5214.473999999999, "marchw2": 7861.661999999998, "marchw3": 7274.555999999999, "marchw4": 5928.959999999999, "marchw5": 4216.277999999999, "ttlMarch": 30495.92999999999, "q1": 45664.571999999986, "aprilw1": 4826.544, "aprilw2": 2372.7419999999997, "aprilw3": 4183.854, "aprilw4": 1880.5919999999996, "ttlApril": 13263.732, "mayw1": 1368.7559999999999, "mayw2": 1382.6519999999998, "mayw3": 2790.7799999999993, "mayw4": 1709.2079999999999, "ttlMay": 7251.395999999999, "junew1": 1760.1599999999999, "junew2": 1776.3719999999998, "junew3": 2695.824, "junew4": 3045.5399999999995, "junew5": 1738.158, "ttlJune": 11016.053999999998, "q2": 31531.181999999997, "julyw1": 3015.4319999999993, "julyw2": 2165.46, "julyw3": 1567.9319999999998, "julyw4": 2948.267999999999, "ttlJuly": 9697.091999999999, "augw1": 1565.6159999999998, "augw2": 2614.7639999999997, "augw3": 5674.2, "augw4": 11219.861999999997, "ttlAugust": 21074.441999999995, "sepw1": 2722.4579999999996, "sepw2": 2813.9399999999996, "sepw3": 2728.248, "sepw4": 2625.1859999999997, "sepw5": 3088.3859999999995, "ttlSeptember": 13978.217999999997, "q3": 44749.751999999986, "octw1": 2470.0139999999997, "octw2": 2316, "octw3": 2316, "octw4": 2161.9859999999994, "ttlOctober": 9263.999999999998, "novw1": 2161.9859999999994, "novw2": 1852.8, "novw3": 1698.7859999999996, "novw4": 1698.7859999999996, "ttlNovember": 7412.357999999998, "novw5": 1698.7859999999996, "decw1": 1698.7859999999996, "decw2": 1543.6139999999998, "decw3": 1852.8, "decw4": 1698.7859999999996, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 64GB", "firstValue": "BBY US", "secondValue": "Customer Forecast", "janw1": 1071.2, "janw2": 1220, "janw3": 1277.6, "janw4": 1147.2, "ttlJanuary": 4716, "febw1": 1042.4, "febw2": 1372.8, "febw3": 1572.8, "febw4": 1775.2, "ttlFebruary": 5763.200000000001, "marchw1": 3602.4, "marchw2": 5431.2, "marchw3": 5025.6, "marchw4": 4096, "marchw5": 2912.8, "ttlMarch": 21068.000000000004, "q1": 31547.200000000004, "aprilw1": 3334.4, "aprilw2": 1639.2, "aprilw3": 2890.4, "aprilw4": 1299.2, "ttlApril": 9163.2, "mayw1": 945.6, "mayw2": 955.2, "mayw3": 1928, "mayw4": 1180.8, "ttlMay": 5009.6, "junew1": 1216, "junew2": 1227.2, "junew3": 1862.4, "junew4": 2104, "junew5": 1200.8, "ttlJune": 7610.400000000001, "q2": 21783.2, "julyw1": 2083.2000000000003, "julyw2": 1496, "julyw3": 1083.2, "julyw4": 2036.8000000000002, "ttlJuly": 6699.200000000001, "augw1": 1081.6000000000001, "augw2": 1806.4, "augw3": 3920, "augw4": 7751.200000000001, "ttlAugust": 14559.2, "sepw1": 1880.8000000000002, "sepw2": 1944, "sepw3": 1884.8000000000002, "sepw4": 1813.6000000000001, "sepw5": 2133.6, "ttlSeptember": 9656.8, "q3": 30915.2, "octw1": 1706.4, "octw2": 1600, "octw3": 1600, "octw4": 1493.6000000000001, "ttlOctober": 6400, "novw1": 1493.6000000000001, "novw2": 1280, "novw3": 1173.6, "novw4": 1173.6, "ttlNovember": 5120.8, "novw5": 1173.6, "decw1": 1173.6, "decw2": 1066.4, "decw3": 1280, "decw4": 1173.6, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 64GB", "secondValue": "Monthly Budget", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 64GB", "secondValue": "Yearly Budget", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0 }, { "columnValue": "Quest 64GB", "secondValue": "Marketing Spend", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 6 }, { "columnValue": "Quest 64GB", "secondValue": "LY Actuals", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Quest 64GB", "secondValue": "Like Item LY", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 79.13499999999999, "q4": 263.34, "totalYear": 1856.0149999999999 }, { "columnValue": "Quest 64GB", "secondValue": "Notes", "janw2": "Email", "janw4": "Ad, Email", "febw2": "10% Price", "febw4": "Free shipping", "marchw3": "Ad", "aprilw1": "Digital Ad", "aprilw4": "Email", "mayw1": "Bundle", "mayw4": "Global homepage", "junew2": "Commercial", "junew5": "In-store hot price", "julyw4": "Online only hot price", "augw4": "Ad", "sepw2": "Bunlde", "sepw5": "Email", "octw2": "Digital ad", "novw1": "Commercial", "novw4": "Email blast", "decw2": "Digital ad", "ttlDecember": 35.699999999999996, "q4": 118.79999999999998, "totalYear": 837.3 }, { "ttlDecember": 6 }, { "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Portal + Black", "secondValue": "Primary Method Base", "janw1": 15.959999999999997, "janw2": 17.29, "janw3": 35.91, "janw4": 16.625, "ttlJanuary": 85.78499999999998, "febw1": 27.264999999999997, "febw2": 18.619999999999997, "febw3": 35.91, "febw4": 23.275, "ttlFebruary": 105.07, "marchw1": 61.179999999999986, "marchw2": 75.145, "marchw3": 96.425, "marchw4": 86.45, "marchw5": 105.07, "ttlMarch": 424.27, "q1": 615.1249999999999, "aprilw1": 57.855, "aprilw2": 79.8, "aprilw3": 51.205, "aprilw4": 51.86999999999999, "ttlApril": 240.73, "mayw1": 43.225, "mayw2": 33.25, "mayw3": 35.24499999999999, "mayw4": 40.56499999999999, "ttlMay": 152.28499999999997, "junew1": 27.264999999999997, "junew2": 20.615, "junew3": 39.9, "junew4": 19.95, "junew5": 22.609999999999996, "ttlJune": 130.33999999999997, "q2": 523.3549999999999, "julyw1": 26.599999999999998, "julyw2": 39.9, "julyw3": 40.56499999999999, "julyw4": 24.604999999999997, "ttlJuly": 131.67, "augw1": 22.609999999999996, "augw2": 22.609999999999996, "augw3": 41.23, "augw4": 79.8, "ttlAugust": 166.24999999999997, "sepw1": 31.254999999999995, "sepw2": 31.254999999999995, "sepw3": 31.254999999999995, "sepw4": 30.589999999999993, "sepw5": 31.919999999999995, "ttlSeptember": 156.27499999999998, "q3": 454.19499999999994, "octw1": 31.919999999999995, "octw2": 28.594999999999995, "octw3": 23.939999999999998, "octw4": 23.939999999999998, "ttlOctober": 108.39499999999998, "novw1": 23.939999999999998, "novw2": 17.29, "novw3": 17.29, "novw4": 17.29, "ttlNovember": 75.81, "novw5": 17.29, "decw1": 14.629999999999997, "decw2": 15.294999999999996, "decw3": 17.29, "decw4": 14.629999999999997, "ttlDecember": 137.802, "q4": 458.5679999999999, "totalYear": 3231.9779999999996 }, { "columnValue": "Portal + Black", "secondValue": "Event Lift", "janw1": 7.199999999999999, "janw2": 7.8, "janw3": 16.2, "janw4": 7.5, "ttlJanuary": 38.7, "febw1": 12.299999999999999, "febw2": 8.4, "febw3": 16.2, "febw4": 10.5, "ttlFebruary": 47.4, "marchw1": 27.599999999999998, "marchw2": 33.9, "marchw3": 43.5, "marchw4": 39, "marchw5": 47.4, "ttlMarch": 191.4, "q1": 277.5, "aprilw1": 26.099999999999998, "aprilw2": 36, "aprilw3": 23.099999999999998, "aprilw4": 23.4, "ttlApril": 108.6, "mayw1": 19.5, "mayw2": 15, "mayw3": 15.899999999999999, "mayw4": 18.3, "ttlMay": 68.7, "junew1": 12.299999999999999, "junew2": 9.299999999999999, "junew3": 18, "junew4": 9, "junew5": 10.2, "ttlJune": 58.8, "q2": 236.1, "julyw1": 12, "julyw2": 18, "julyw3": 18.3, "julyw4": 11.1, "ttlJuly": 59.4, "augw1": 10.2, "augw2": 10.2, "augw3": 18.599999999999998, "augw4": 36, "ttlAugust": 75, "sepw1": 14.1, "sepw2": 14.1, "sepw3": 14.1, "sepw4": 13.799999999999999, "sepw5": 14.399999999999999, "ttlSeptember": 70.5, "q3": 204.9, "octw1": 14.399999999999999, "octw2": 12.9, "octw3": 10.799999999999999, "octw4": 10.799999999999999, "ttlOctober": 48.9, "novw1": 10.799999999999999, "novw2": 7.8, "novw3": 7.8, "novw4": 7.8, "ttlNovember": 34.199999999999996, "novw5": 7.8, "decw1": 6.6, "decw2": 6.8999999999999995, "decw3": 7.8, "decw4": 6.6, "ttlDecember": 95.2, "q4": 316.8, "totalYear": 2232.8 }, { "columnValue": "Portal + Black", "secondValue": "Seasonality", "janw1": 1.2, "janw2": 1.2, "janw3": 1.2, "janw4": 1.2, "ttlJanuary": 4.8, "febw1": 1.2, "febw2": 1.2, "febw3": 1.2, "febw4": 1.2, "ttlFebruary": 4.8, "marchw1": 1.2, "marchw2": 1.2, "marchw3": 1.2, "marchw4": 1.2, "marchw5": 1.2, "ttlMarch": 6, "aprilw1": 1.2, "aprilw2": 1.2, "aprilw3": 1.2, "aprilw4": 1.2, "ttlApril": 4.8, "mayw1": 1.2, "mayw2": 1.2, "mayw3": 1.2, "mayw4": 1.2, "ttlMay": 4.8, "junew1": 1.2, "junew2": 1.2, "junew3": 1.2, "junew4": 1.2, "junew5": 1.2, "ttlJune": 6, "julyw1": 1.2, "julyw2": 1.2, "julyw3": 1.2, "julyw4": 1.2, "ttlJuly": 4.8, "augw1": 1.2, "augw2": 1.2, "augw3": 1.2, "augw4": 1.2, "ttlAugust": 4.8, "sepw1": 1.2, "sepw2": 1.2, "sepw3": 1.2, "sepw4": 1.2, "sepw5": 1.2, "ttlSeptember": 6, "octw1": 1.2, "octw2": 1.2, "octw3": 1.2, "octw4": 1.2, "ttlOctober": 4.8, "novw1": 1.2, "novw2": 1.2, "novw3": 1.2, "novw4": 1.2, "ttlNovember": 4.8, "novw5": 1.2, "decw1": 1.2, "decw2": 1.2, "decw3": 1.2, "decw4": 1.2, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Portal + Black", "secondValue": "Total Forecast", "janw1": 0, "janw2": 0, "janw3": 0, "janw4": 0, "ttlJanuary": 0, "febw1": 0, "febw2": 0, "febw3": 0, "febw4": 0, "ttlFebruary": 0, "marchw1": 0, "marchw2": 0, "marchw3": 0, "marchw4": 0, "marchw5": 0, "ttlMarch": 0, "q1": 0, "aprilw1": 0, "aprilw2": 0, "aprilw3": 0, "aprilw4": 0, "ttlApril": 0, "mayw1": 0, "mayw2": 0, "mayw3": 0, "mayw4": 0, "ttlMay": 0, "junew1": 0, "junew2": 0, "junew3": 0, "junew4": 0, "junew5": 0, "ttlJune": 0, "q2": 0, "julyw1": 0, "julyw2": 0, "julyw3": 0, "julyw4": 0, "ttlJuly": 0, "augw1": 0, "augw2": 0, "augw3": 0, "augw4": 0, "ttlAugust": 0, "sepw1": 0, "sepw2": 0, "sepw3": 0, "sepw4": 0, "sepw5": 0, "ttlSeptember": 0, "q3": 0, "octw1": 0, "octw2": 0, "octw3": 0, "octw4": 0, "ttlOctober": 0, "novw1": 0, "novw2": 0, "novw3": 0, "novw4": 0, "ttlNovember": 0, "novw5": 0, "decw1": 0, "decw2": 0, "decw3": 0, "decw4": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Portal + Black", "firstValue": "Portal + Black", "secondValue": "Final Total Forecast", "janw1": 27.791999999999994, "janw2": 30.107999999999997, "janw3": 62.532, "janw4": 28.95, "ttlJanuary": 149.382, "febw1": 47.477999999999994, "febw2": 32.42399999999999, "febw3": 62.532, "febw4": 40.529999999999994, "ttlFebruary": 182.964, "marchw1": 106.53599999999999, "marchw2": 130.85399999999998, "marchw3": 167.91, "marchw4": 150.54, "marchw5": 182.964, "ttlMarch": 738.804, "q1": 1071.15, "aprilw1": 100.746, "aprilw2": 138.95999999999998, "aprilw3": 89.16599999999998, "aprilw4": 90.32399999999997, "ttlApril": 419.1959999999999, "mayw1": 75.27, "mayw2": 57.9, "mayw3": 61.37399999999998, "mayw4": 70.63799999999999, "ttlMay": 265.18199999999996, "junew1": 47.477999999999994, "junew2": 35.897999999999996, "junew3": 69.47999999999999, "junew4": 34.739999999999995, "junew5": 39.37199999999999, "ttlJune": 226.96799999999996, "q2": 911.3459999999998, "julyw1": 46.31999999999999, "julyw2": 69.47999999999999, "julyw3": 70.63799999999999, "julyw4": 42.846, "ttlJuly": 229.28399999999996, "augw1": 39.37199999999999, "augw2": 39.37199999999999, "augw3": 71.79599999999999, "augw4": 138.95999999999998, "ttlAugust": 289.49999999999994, "sepw1": 54.425999999999995, "sepw2": 54.425999999999995, "sepw3": 54.425999999999995, "sepw4": 53.267999999999994, "sepw5": 55.58399999999999, "ttlSeptember": 272.12999999999994, "q3": 790.9139999999999, "octw1": 55.58399999999999, "octw2": 49.794, "octw3": 41.687999999999995, "octw4": 41.687999999999995, "ttlOctober": 188.75399999999996, "novw1": 41.687999999999995, "novw2": 30.107999999999997, "novw3": 30.107999999999997, "novw4": 30.107999999999997, "ttlNovember": 132.01199999999997, "novw5": 30.107999999999997, "decw1": 25.475999999999996, "decw2": 26.633999999999997, "decw3": 30.107999999999997, "decw4": 25.475999999999996, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Portal + Black", "firstValue": "BBY US", "secondValue": "Customer Forecast", "janw1": 19.2, "janw2": 20.8, "janw3": 43.2, "janw4": 20, "ttlJanuary": 103.2, "febw1": 32.800000000000004, "febw2": 22.400000000000002, "febw3": 43.2, "febw4": 28, "ttlFebruary": 126.4, "marchw1": 73.6, "marchw2": 90.4, "marchw3": 116, "marchw4": 104, "marchw5": 126.4, "ttlMarch": 510.4, "q1": 740, "aprilw1": 69.60000000000001, "aprilw2": 96, "aprilw3": 61.6, "aprilw4": 62.400000000000006, "ttlApril": 289.6, "mayw1": 52, "mayw2": 40, "mayw3": 42.4, "mayw4": 48.800000000000004, "ttlMay": 183.2, "junew1": 32.800000000000004, "junew2": 24.8, "junew3": 48, "junew4": 24, "junew5": 27.200000000000003, "ttlJune": 156.8, "q2": 629.6, "julyw1": 32, "julyw2": 48, "julyw3": 48.800000000000004, "julyw4": 29.6, "ttlJuly": 158.4, "augw1": 27.200000000000003, "augw2": 27.200000000000003, "augw3": 49.6, "augw4": 96, "ttlAugust": 200, "sepw1": 37.6, "sepw2": 37.6, "sepw3": 37.6, "sepw4": 36.8, "sepw5": 38.4, "ttlSeptember": 187.99999999999997, "q3": 546.4, "octw1": 38.4, "octw2": 34.4, "octw3": 28.8, "octw4": 28.8, "ttlOctober": 130.4, "novw1": 28.8, "novw2": 20.8, "novw3": 20.8, "novw4": 20.8, "ttlNovember": 91.2, "novw5": 20.8, "decw1": 17.6, "decw2": 18.4, "decw3": 20.8, "decw4": 17.6, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Portal + Black", "secondValue": "Monthly Budget", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0, "ttlDecember": 0, "q4": 0, "totalYear": 0 }, { "columnValue": "Portal + Black", "secondValue": "Yearly Budget", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0 }, { "columnValue": "Portal + Black", "secondValue": "Marketing Spend", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0 }, { "columnValue": "Portal + Black", "secondValue": "LY Actuals", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0 }, { "columnValue": "Portal + Black", "secondValue": "Like Item LY", "ttlJanuary": 0, "ttlFebruary": 0, "ttlMarch": 0, "q1": 0, "ttlApril": 0, "ttlMay": 0, "ttlJune": 0, "q2": 0, "ttlJuly": 0, "ttlAugust": 0, "ttlSeptember": 0, "q3": 0, "ttlOctober": 0, "ttlNovember": 0 }, { "columnValue": "Portal + Black", "secondValue": "Notes", "janw2": "Email", "janw4": "Ad, Email", "febw2": "10% Price", "febw4": "Free shipping", "marchw3": "Ad", "aprilw1": "Digital Ad", "aprilw4": "Email", "mayw1": "Bundle", "mayw4": "Global homepage", "junew2": "Commercial", "junew5": "In-store hot price", "julyw4": "Online only hot price", "augw4": "Ad", "sepw2": "Bunlde", "sepw5": "Email", "octw2": "Digital ad", "novw1": "Commercial", "novw4": "Email blast", "decw2": "Digital ad" }]
    this.tempList = JSON.parse(JSON.stringify(this.rowList));
    this.calculateListValues();
  }
  public calculateListValues = (event?, changedList?) => {
    if (event) {
      const index = this.rowList.findIndex(row => row.secondValue === event.data.secondValue && row.columnValue === event.data.columnValue);
      if (index > -1) {
        event.newValue = +event.newValue;
        this.tempList[index][event.colDef.field] = Number(event.newValue);
      }
    }
    this.tempList.forEach(row => {
      if (row.secondValue === 'Total Forecast' || row.secondValue === 'Mostly likely Method' || (row.secondValue === 'Final Total Forecast' && row.columnValue === 'Calculated')) {
        Object.keys(row).forEach(key => {
          if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
            row[key] = 0;
          }
        });
      }
    });
    this.tempList.forEach(row => {
      const selectedColumnList = this.chooserList.filter(row => !row.checked).map(el => el.name);
      if (row.secondValue === 'Total Forecast') {
        let list = ['Primary Method Base', 'Expotential Smoothing', 'Linear Regression', `Holt's Double Expotential Smoothing`, 'Event Lift', 'Seasonality'];
        if (selectedColumnList.length > 0) {
          list = list.filter(item => !selectedColumnList.includes(item));
        }
        let toFindList = changedList ? changedList : this.tempList;
        const calculationList = toFindList.filter(item => list.includes(item.secondValue) && item.columnValue === row.columnValue);
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              if (element.secondValue !== 'Seasonality') {
                row[key] = +row[key];
                element[key] = +element[key];
                row[key] += +element[key];
              }
            }
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (element.secondValue !== 'Seasonality' && flag) {
                row[key] = +row[key];
                element[key] = +element[key];
                row[key] += +element[key];
              }
            }
          });
        });
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              if (element.secondValue === 'Seasonality') {
                row[key] = +row[key];
                row[key] *= +element[key];
              }
            }
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (element.secondValue === 'Seasonality' && flag) {
                row[key] = +row[key];
                row[key] *= +element[key];
              }
            }
          });
        });
      }
      row['ttlJanuary'] = 0;
      row['ttlFebruary'] = 0;
      row['ttlMarch'] = 0;
      row['ttlApril'] = 0;
      row['ttlMay'] = 0;
      row['ttlJune'] = 0;
      row['ttlJuly'] = 0;
      row['ttlAugust'] = 0;
      row['ttlSeptember'] = 0;
      row['ttlOctober'] = 0;
      row['ttlNovember'] = 0;
      row['ttlDecember'] = 0;
      Object.keys(row).forEach(key => {
        const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
        if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && row.secondValue !== 'Notes' && columns.length < 1) {
          if (key.startsWith('jan')) {
            row['ttlJanuary'] += +row[key];
          }
          if (key.startsWith('feb')) {
            row['ttlFebruary'] += +row[key];
          }
          if (key.startsWith('march')) {
            row['ttlMarch'] += +row[key];
          }
          if (key.startsWith('april')) {
            row['ttlApril'] += +row[key];
          }
          if (key.startsWith('may')) {
            row['ttlMay'] += +row[key];
          }
          if (key.startsWith('june')) {
            row['ttlJune'] += +row[key];
          }
          if (key.startsWith('july')) {
            row['ttlJuly'] += +row[key];
          }
          if (key.startsWith('aug')) {
            row['ttlAugust'] += +row[key];
          }
          if (key.startsWith('sep')) {
            row['ttlSeptember'] += +row[key];
          }
          if (key.startsWith('oct')) {
            row['ttlOctober'] += +row[key];
          }
          if (key.startsWith('nov')) {
            row['ttlNovember'] += +row[key];
          }
          if (key.startsWith('dec')) {
            row['ttlDecember'] += +row[key];
          }
          row['q1'] = row['ttlJanuary'] + row['ttlFebruary'] + row['ttlMarch'];
          row['q2'] = row['ttlApril'] + row['ttlMay'] + row['ttlJune'];
          row['q3'] = row['ttlJuly'] + row['ttlAugust'] + row['ttlSeptember'];
          row['q4'] = row['ttlOctober'] + row['ttlNovember'] + row['ttlDecember'];
          row['totalYear'] = row['q1'] + row['q2'] + row['q3'] + row['q4'];
        }
        if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && row.secondValue !== 'Notes' && columns.length > 0) {
          const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
          if (key.startsWith('jan') && flag) {
            row['ttlJanuary'] += +row[key];
          }
          if (key.startsWith('feb') && flag) {
            row['ttlFebruary'] += +row[key];
          }
          if (key.startsWith('march') && flag) {
            row['ttlMarch'] += +row[key];
          }
          if (key.startsWith('april') && flag) {
            row['ttlApril'] += +row[key];
          }
          if (key.startsWith('may') && flag) {
            row['ttlMay'] += +row[key];
          }
          if (key.startsWith('june') && flag) {
            row['ttlJune'] += +row[key];
          }
          if (key.startsWith('july') && flag) {
            row['ttlJuly'] += +row[key];
          }
          if (key.startsWith('aug') && flag) {
            row['ttlAugust'] += +row[key];
          }
          if (key.startsWith('sep') && flag) {
            row['ttlSeptember'] += +row[key];
          }
          if (key.startsWith('oct') && flag) {
            row['ttlOctober'] += +row[key];
          }
          if (key.startsWith('nov') && flag) {
            row['ttlNovember'] += +row[key];
          }
          if (key.startsWith('dec') && flag) {
            row['ttlDecember'] += +row[key];
          }
          row['q1'] = row['ttlJanuary'] + row['ttlFebruary'] + row['ttlMarch'];
          row['q2'] = row['ttlApril'] + row['ttlMay'] + row['ttlJune'];
          row['q3'] = row['ttlJuly'] + row['ttlAugust'] + row['ttlSeptember'];
          row['q4'] = row['ttlOctober'] + row['ttlNovember'] + row['ttlDecember'];
          row['totalYear'] = row['q1'] + row['q2'] + row['q3'] + row['q4'];
          if (row.secondValue === 'Seasonality') {
            row['ttlJanuary'] = +row['ttlJanuary'].toFixed(2);
            row['ttlFebruary'] = +row['ttlFebruary'].toFixed(2);
            row['ttlMarch'] = +row['ttlMarch'].toFixed(2);
            row['ttlApril'] = +row['ttlApril'].toFixed(2);
            row['ttlMay'] = +row['ttlMay'].toFixed(2);
            row['ttlJune'] = +row['ttlJune'].toFixed(2);
            row['ttlJuly'] = +row['ttlJuly'].toFixed(2);
            row['ttlAugust'] = +row['ttlAugust'].toFixed(2);
            row['ttlSeptember'] = +row['ttlSeptember'].toFixed(2);
            row['ttlOctober'] = +row['ttlOctober'].toFixed(2);
            row['ttlNovember'] = +row['ttlNovember'].toFixed(2);
            row['ttlDecember'] = +row['ttlDecember'].toFixed(2);
            row['q1'] = +row['q1'].toFixed(2);
            row['q2'] = +row['q2'].toFixed(2);
            row['q3'] = +row['q3'].toFixed(2);
            row['q4'] = +row['q4'].toFixed(2);
          }
        }
      });
      if (row.secondValue === 'Mostly likely Method' && row.columnValue === 'Calculated') {
        const items = ['Primary Method Base', 'Expotential Smoothing', 'Linear Regression', `Holt's Double Expotential Smoothing`];
        let toFindList = changedList ? changedList : this.tempList;
        const calculationList = toFindList.filter(item => (items.includes(item.secondValue)) && item.columnValue !== 'Calculated');
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
              row[key] = +row[key];
              row[key] += +element[key];
            }
          });
        });
      }
      if (row.secondValue === 'Final Total Forecast' && row.columnValue === 'Calculated') {
        let toFindList = changedList ? changedList : this.tempList;
        const calculationList = toFindList.filter(item => (item.secondValue === 'Final Total Forecast') && item.columnValue !== 'Calculated');
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
              row[key] = +row[key];
              row[key] += +element[key];
            }
          });
        });
      }
    });
    this.totalCalculatedList = this.tempList.filter(item => item.columnValue === 'Calculated');
    const selectedColumnList = this.chooserList.filter(row => !row.checked).map(el => el.name);
    let list = this.tempList;
    if (selectedColumnList.length > 0) {
      list = this.tempList.filter(row => !selectedColumnList.includes(row.secondValue));
    }
    for (let index = 0; index < list.length; index++) {
      Object.keys(list[index]).forEach(key => {
        if (!isNaN(list[index][key])) {
          if (list[index].secondValue !== 'Seasonality') {
            list[index][key] = list[index][key] ? Number(list[index][key]).toFixed(0) : 0;
          }
        }
      })
    }
    list = list.filter(row => row.columnValue !== 'Calculated');
    setTimeout(() => {
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.setRowData(list);
      }
    }, 100);

    this.applyGraph(this.totalCalculatedList);
    const objList = [];
    const object = this.totalCalculatedList[1];
    this.chartDatasets = this.totalCalculatedList.map(row => ({
      name: row.secondValue,
      series: this.getSeries(object)
    }))
    console.log(objList);
    for (let index = 0; index < this.rowList.length; index++) {
      Object.keys(this.rowList[index]).forEach(key => {
        if (!isNaN(this.rowList[index][key])) {
          if (this.rowList[index].secondValue !== 'Seasonality') {
            this.rowList[index][key] = this.rowList[index][key] ? Number(this.rowList[index][key]).toFixed(0) : 0;
          }
        }
      })
    }

    // this.rowList = list;
  }
  getSeries = (object) => {
    const objList = [];
    Object.keys(object).forEach(key => {
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
        const newObject = {
          name: key,
          value: Number(object[key])
        }
        objList.push(newObject)
      }
    });
    return objList;
  }
  openExcelImportDialog(data, templateRef?: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(this.excelImport, { width: '500px', data: data || {} });
  }
  onCellValueChanged = (value) => {
    this.calculateListValues(value);
  }
  onFilterTextBoxChanged(event) {
    this.gridOptions.api.setQuickFilter(event.target.value);
  }
  onGridReady(params) {
    this.gridApi = params.api;
  }
  public onSubmit = () => {
  }
  selectAllSelected(flag: boolean): void {
    if (flag) {
      this.chooserList = this.chooserList.map(row => ({ ...row, checked: true }))
    } else {
      this.chooserList = this.chooserList.map(row => ({ ...row, checked: false }))
    }
  }
  public onSave = () => {
    // let newColumnDefs = this.columnDefs.filter(column => column.show);
    // const cols = JSON.parse(JSON.stringify(this.tempColDefs));
    // const list = cols.map(column => {
    //   if (column.children) {
    //     column.children = column.children.filter(col => col.show);
    //     column.children = column.children.map(col => ({ ...col, editable: params => { return params.data['secondValue'] !== 'Total Forecast' } }))
    //   }
    //   return column;
    // });
    // newColumnDefs = newColumnDefs.length > 0 ? list.push(...newColumnDefs) : list as any;
    // this.gridOptions.api.setColumnDefs(newColumnDefs);
    this.calculateListValues();
    this.dialogRef.close();
  }
  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }
  exportToExcel = () => {
    this.gridApi.exportDataAsCsv();
  }
  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }
  loadFile(res) {

    /* wire up file reader */
    this.spinner.show();
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(res);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary', cellDates: true });
      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      console.log(data);
      this.rowList = data;
      console.log(JSON.stringify(this.rowList));
      // for (let i = 0; i < this.ItemMasterList.length; i++) {
      //   if (this.ItemMasterList[i]['']) {
      //     this.ItemMasterList[i][''] =
      //   }
      // }
      this.spinner.hide();
    };
  }
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.itemSeletedList.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.searchItem.setValue('');
  }

  remove(fruit: string): void {
    const index = this.itemSeletedList.indexOf(fruit);

    if (index >= 0) {
      this.itemSeletedList.splice(index, 1);
    }
  }
  selected(event: MatAutocompleteSelectedEvent): void {
    this.itemSeletedList.push(event.option.viewValue);
    this.searchItemInput.nativeElement.value = '';
    this.searchItem.setValue(null);
  }
  selectedCustomer(event: MatAutocompleteSelectedEvent): void {
    this.customerSelectedList.push(event.option.viewValue);
    this.searchCustomerInput.nativeElement.value = '';
    this.searchCustomer.setValue(null);
  }
  removeCustomer(fruit: string): void {
    const index = this.customerSelectedList.indexOf(fruit);

    if (index >= 0) {
      this.customerSelectedList.splice(index, 1);
    }
  }
  addCustomer(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our Customer
    if ((value || '').trim()) {
      this.customerSelectedList.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.searchCustomer.setValue('');
  }
  onItemSelect(item?: boolean, items?) {
    var columns = [];
    var newColumnDefs = [];
    columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
    // const columnDefs = this.columnDefs;
    if (columns && columns.length > 0 && !item) {
      const columnDefs = JSON.parse(JSON.stringify(this.tempColDefs));
      const list = columnDefs.map(column => {
        if (column.children) {
          // || col.field.startsWith('q') || col.field.startsWith('totalYear')
          column.children = column.children.filter(col => columns.findIndex((a, b) => col.field.indexOf(a) > -1) > -1);
          column.children = column.children.map(col => ({ ...col, editable: params => { return params.data['secondValue'] !== 'Total Forecast' } }))
        }
        return column;
      });
      newColumnDefs = newColumnDefs.length > 0 ? list.push(...newColumnDefs) : list as any;
      newColumnDefs = newColumnDefs.filter(col => columns.findIndex((a, b) => ((col.field === '' || col.pinned))) > -1);
      // newColumnDefs = newColumnDefs.filter(col => (col.field === '' || col.pinned));
      newColumnDefs = newColumnDefs.map(col => ({ ...col, cellRenderer: col.field === 'firstValue' ? params => `<b>${params.value ? params.value : ''}</b>` : null }))
      for (let i = 0; i < newColumnDefs.length; i++) {
        if (newColumnDefs[i].field === 'secondValue') {
          newColumnDefs[i] = {
            ...newColumnDefs[i],
            cellRenderer: 'dropdownRenderer',
            cellRendererParams: (params) => {
              const items = ['Primary Method Base', 'Expotential Smoothing', 'Linear Regression', `Holt's Double Expotential Smoothing`];
              const obj = {
                isDropDown: items.includes(params.data.secondValue) ? true : false, // pass the field value here
                onChange: this.filterData.bind(this),
              }
              return obj;
            },
          }
        }
      }
      this.gridOptions.api.setColumnDefs(newColumnDefs);
    } else {
      if (item) {
        this.timeframeSelectedList = items
      }
      this.gridOptions.api.setColumnDefs(this.columnDefs);
    }
    // if (columns && columns.length > 0) {
    //   columnDefs.forEach(colm => {
    //     colm.children = colm.children && colm.children.length > 0 ? colm && colm.children.filter(col => columns.findIndex((a, b) => col.field.indexOf(a) > -1) > -1) : colm.children
    //   });
    // }
    this.calculateListValues();
  }
  onSelectAll(items: any) {
    this.onItemSelect(true, items)
  }
  openFullScreen = (id: string) => {
    const domGrid = document.getElementById(id) as any;
    if (domGrid) {
      domGrid.webkitRequestFullscreen();
    }
  }
  applyGraph(totalCalculatedList) {
    const data = {
      chart: {
        caption: "",
        yaxisname: "",
        subcaption: "",
        showhovereffect: "1",
        lineThickness: "4",
        "width": "100%",
        "height": "150px",
        numbersuffix: "",
        "paletteColors": "#8D009D,#F8486E, #1C9FAD, #2480D3",
        drawcrossline: "1",
        plottooltext: "<b>$dataValue</b>",
        theme: "fusion"
      },
      categories: [
        {
          category: this.getLabels()
        }
      ],
      dataset: this.totalCalculatedList.map(item => ({ seriesname: item.secondValue, data: this.getList(item) }))
    };
    this.dataSource = data as any;
  }
  public getLabels = () => {
    const el = this.totalCalculatedList[0];
    const list = [];
    Object.keys(el).forEach(key => {
      const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
        list.push({ label: this.getKeyValue(key) });
      }
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
        const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
        if (flag) {
          list.push({ label: this.getKeyValue(key) });
        }
      }
    });
    return list;
  }
  getKeyValue(key) {
    const list = [
      { key: 'janw1', value: '01/05/2020' },
      { key: 'janw2', value: '01/12/2020' },
      { key: 'janw3', value: '01/19/2020' },
      { key: 'janw4', value: '01/26/2020' },
      { key: 'ttlJanuary', value: 'Total January' },
      { key: 'febw1', value: '02/02/2020' },
      { key: 'febw2', value: '02/09/2020' },
      { key: 'febw3', value: '02/16/2020' },
      { key: 'febw4', value: '02/23/2020' },
      { key: 'ttlFebruary', value: 'Total February' },
      { key: 'marchw1', value: '03/01/2020' },
      { key: 'marchw2', value: '03/08/2020' },
      { key: 'marchw3', value: '03/15/2020' },
      { key: 'marchw4', value: '03/22/2020' },
      { key: 'marchw5', value: '03/29/2020' },
      { key: 'ttlMarch', value: 'Total March' },
      { key: 'q1', value: 'Q1' },
      { key: 'aprilw1', value: '04/05/2020' },
      { key: 'aprilw2', value: '04/12/2020' },
      { key: 'aprilw3', value: '04/19/2020' },
      { key: 'aprilw4', value: '04/26/2020' },
      { key: 'ttlApril', value: 'Total April' },
      { key: 'mayw1', value: '05/03/2020' },
      { key: 'mayw2', value: '05/10/2020' },
      { key: 'mayw3', value: '05/17/2020' },
      { key: 'mayw4', value: '05/24/2020' },
      { key: 'ttlMay', value: 'Total May' },
      { key: 'junew1', value: '05/31/2020' },
      { key: 'junew2', value: '06/07/2020' },
      { key: 'junew3', value: '06/14/2020' },
      { key: 'junew4', value: '06/21/2020' },
      { key: 'junew5', value: '06/28/2020' },
      { key: 'ttlJune', value: 'Total June' },
      { key: 'q2', value: 'Q2' },
      { key: 'julyw1', value: '07/05/2020' },
      { key: 'julyw2', value: '07/12/2020' },
      { key: 'julyw3', value: '07/19/2020' },
      { key: 'julyw4', value: '07/26/2020' },
      { key: 'ttlJuly', value: 'Total July' },
      { key: 'augw1', value: '08/02/2020' },
      { key: 'augw2', value: '08/09/2020' },
      { key: 'augw3', value: '08/16/2020' },
      { key: 'augw4', value: '08/23/2020' },
      { key: 'ttlAugust', value: 'Total August' },
      { key: 'sepw1', value: '09/30/2020' },
      { key: 'sepw2', value: '09/06/2020' },
      { key: 'sepw3', value: '09/13/2020' },
      { key: 'sepw4', value: '09/20/2020' },
      { key: 'sepw5', value: '09/27/2020' },
      { key: 'ttlSeptember', value: 'Total September' },
      { key: 'q3', value: 'Q3' },
      { key: 'octw1', value: '10/04/2020' },
      { key: 'octw2', value: '10/11/2020' },
      { key: 'octw3', value: '10/18/2020' },
      { key: 'octw4', value: '10/25/2020' },
      { key: 'ttlOctober', value: 'Total October' },
      { key: 'novw1', value: '11/01/2020' },
      { key: 'novw2', value: '11/08/2020' },
      { key: 'novw3', value: '11/15/2020' },
      { key: 'novw4', value: '11/22/2020' },
      { key: 'ttlNovember', value: 'Total November' },
      { key: 'novw5', value: '11/29/2020' },
      { key: 'decw1', value: '12/06/2020' },
      { key: 'decw2', value: '12/13/2020' },
      { key: 'decw3', value: '12/20/2020' },
      { key: 'decw4', value: '12/27/2020' },
      { key: 'ttlDecember', value: 'Total December' },
      { key: 'q4', value: 'Q4' },
      { key: 'totalYear', value: 'Total Year' },
    ];
    return list.find(item => item.key === key).value;
  }
  getList = (row) => {
    const list = [];
    Object.keys(row).forEach(key => {
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
        list.push(row[key]);
      }
    });
    return list.map(item => ({ value: item }))
  }
  filterData = (value) => {
    const index = value.rowData.rowIndex + 4;
    const list = JSON.parse(JSON.stringify(this.tempList));
    Object.keys(list[index]).forEach(key => {
      if (key !== 'firstValue' && key !== 'columnValue') {
        if ((key.endsWith('w1') || key.endsWith('w2') || key.endsWith('w3') || key.endsWith('w4') || key.endsWith('w5'))) {
          if (value.event.value === 'Linear Regression') {
            list[index][key] = +list[index][key];
            list[index][key] *= 1.2;
          } else if (value.event.value === `Holt's Double Expotential Smoothing`) {
            list[index][key] = +list[index][key];
            list[index][key] *= 0.8;
          } else {
            list[index][key] = +this.rowList[index][key];
            // list[index][key] *= 0.8;
          }
        }
        if (key === 'secondValue') {
          list[index][key] = value.event.value;
        }
      }
    });
    this.tempList = [...list];
    this.calculateListValues(null, list);
  }
}
